/**
 * Per-solution calibration step lists for the three info-only
 * DIY analytical solutions (Enhancement J).
 *
 * Only these three slugs get an interactive checklist; all other
 * solutions render nothing from CalibrationHelper.
 */
export const CALIBRATION_STEPS: Record<string, string[]> = {
  'alk-test': [
    'Measure 100 mL of aquarium water using a graduated cylinder.',
    'Add 5 drops of indicator solution; sample turns blue.',
    'Fill burette with 0.1 N HCl titrant to the zero mark.',
    'Slowly add titrant while swirling until sample turns pink/red.',
    'Record total mL of titrant used.',
    'Calculate dKH: (mL titrant × 2.8) = dKH.',
  ],
  'alk-standard': [
    'Dry primary-standard Sodium Carbonate at 180–200 °C for 2+ hours.',
    'Cool in a dessicator to room temperature.',
    'Weigh exactly 1.060 g on a calibrated analytical balance.',
    'Quantitatively transfer to a 1 L Class A volumetric flask.',
    'Dissolve in RO/DI water, then fill to the 1 L mark.',
    'Mix thoroughly; standard is 56 dKH.',
    'Verify your test kit reads 56 ± 0.5 dKH using this standard.',
  ],
  'salinity-standard': [
    'Weigh 3.65 g of pure (non-iodized) NaCl.',
    'Weigh 96.35 g of RO/DI water (or measure 96.35 mL).',
    'Combine and stir until fully dissolved.',
    'Bring sample to 25 °C (refractometers are temperature sensitive).',
    'Apply a few drops to the refractometer prism.',
    'Adjust the calibration screw until the reading is 35 ppt / 1.0264 SG.',
  ],
};
